import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faWindowClose, faWindowMinimize } from '@fortawesome/free-solid-svg-icons';
import { AvmTimeSpentPipe } from '@hub4b/pipes/avm-form-time-spent.pipe';

@Component({
    selector: 'app-reminder-notification',
    templateUrl: './reminder-notification.component.html',
    styleUrls: ['./reminder-notification.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CdkDrag, CdkDragHandle, FaIconComponent, AvmTimeSpentPipe]
})
export class ReminderNotificationComponent {
    /**
     * Références des icônes utilisés dans le template.
     */
    public minimizeIcon = faWindowMinimize;
    public closeIcon = faWindowClose;

    /**
     * Titre de la notification.
     */
    @Input()
    public title: string;

    /**
     * Texte de la notification.
     */
    @Input()
    public text: string;

    /**
     * Date de création de la notification.
     */
    @Input()
    public creationDate: Date;

    /**
     * Emis lorsque l'utilisateur ferme la notification.
     */
    @Output()
    public closed: EventEmitter<boolean> = new EventEmitter();

    /**
     * Valeur indiquant si la notification est cachée.
     */
    public hidden: boolean = false;

    /**
     * Position de la notification.
     */
    dragPosition = { x: 10, y: 10 };

    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Réduire' de la notification.
     */
    public onMinimize(): void {
        this.hidden = true;
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Femer' de la notification.
     */
    public onClose(): void {
        this.hidden = true;
        this.closed.emit(true);
    }
}
